import { render } from "./EditTraining.vue?vue&type=template&id=f652b5d8&scoped=true"
import script from "./EditTraining.vue?vue&type=script&lang=js"
export * from "./EditTraining.vue?vue&type=script&lang=js"

import "./EditTraining.vue?vue&type=style&index=0&id=f652b5d8&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f652b5d8"]])

export default __exports__